import React from "react";
import { Box, Select, MenuItem, Typography } from "@mui/material";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";

const dropdownSx = {
  fontSize: 13,
  fontWeight: 600,
  color: "#344054",
  bgcolor: "#fff",
  minWidth: 160,
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "#d0d7e2" },
  "& .MuiSelect-select": { display: "flex", alignItems: "center", gap: 1, py: "8px" },
};

function formatDateOption(value) {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

/**
 * "Run" picker for the Detail tab — backed by GET /conversation-monitoring/dates
 * (`dates`, latest first). Falls back to a single non-interactive "Latest"
 * entry when no dates are available (e.g. runLabel is still the caller's
 * best guess from currentRunDate).
 */
export default function FilterBar({ runLabel = "Latest", dates = [], selectedDate, onDateChange }) {
  const hasDates = dates.length > 0;
  const value = hasDates ? selectedDate || dates[0]?.execution_start_time || "" : "latest";

  return (
    <Box
      sx={{
        bgcolor: "#fff",
        borderRadius: "8px",
        boxShadow: "0px 3.5px 5.5px 0px rgba(0,0,0,0.05)",
        p: "14px 24px",
        display: "flex",
        alignItems: "center",
        gap: 1.25,
      }}
    >
      <Typography sx={{ fontSize: 12.5, fontWeight: 600, color: "#667085" }}>Run</Typography>
      <Select
        size="small"
        value={value}
        onChange={(e) => onDateChange?.(e.target.value)}
        sx={{ ...dropdownSx, minWidth: 200 }}
      >
        {hasDates ? (
          dates.map((d) => (
            <MenuItem key={d.id} value={d.execution_start_time}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CalendarTodayOutlinedIcon sx={{ fontSize: 14, color: "#667085" }} />
                {formatDateOption(d.execution_start_time)}
              </Box>
            </MenuItem>
          ))
        ) : (
          <MenuItem value="latest">
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CalendarTodayOutlinedIcon sx={{ fontSize: 14, color: "#667085" }} />
              {runLabel}
            </Box>
          </MenuItem>
        )}
      </Select>
    </Box>
  );
}
